import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';
import type { Job } from '../types/job';

export function useJobs() {
  const [jobs, setJobs] = useState<Job[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchJobs = async () => {
    try {
      const { data, error: fetchError } = await supabase
        .from('nrm_jobs')
        .select(`
          *,
          company:company_id (
            id,
            name
          )
        `)
        .order('updated_at', { ascending: false });

      if (fetchError) throw fetchError;
      setJobs(data || []);
    } catch (err) {
      setError('Failed to load jobs');
      console.error('Fetch error:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchJobs();
  }, []);

  return { jobs, loading, error, refetch: fetchJobs };
}